/**
 * The assistant's mark.
 *
 * Upstream drew Tulkey as an inline SVG carrying the mascot's own palette —
 * a green head, a red topi, a near-black outline. mm-web forbids a literal
 * colour in any `.tsx`, and the rail already draws this character from
 * `@/assets/icons/mitra-ai.png`, so the same raster is the mark here and the
 * two sites cannot drift. The export name and props are unchanged: every
 * caller still asks for a `size` and hands a `className`.
 *
 * `alt=""` because the mark is decorative everywhere it is drawn — the
 * transcript names the speaker in an `sr-only` span beside it, and the panel
 * header carries the product name as text.
 */
import mitraAiIcon from '@/assets/icons/mitra-ai.png'

export function Mitramark({ size, className }: { size: number; className?: string }) {
  return (
    <img
      src={mitraAiIcon}
      alt=""
      width={size}
      height={size}
      className={className}
      draggable={false}
    />
  )
}
